import { render, staticRenderFns } from "./SpaCardsAutoGrid.vue?vue&type=template&id=897d2738&"
import script from "./SpaCardsAutoGrid.vue?vue&type=script&lang=js&"
export * from "./SpaCardsAutoGrid.vue?vue&type=script&lang=js&"
import style0 from "./SpaCardsAutoGrid.vue?vue&type=style&index=0&id=897d2738&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports